function imposeMinMax(el){
  if(el.value != ""){
    if(parseInt(el.value) < parseInt(el.min)){
      el.value = el.min;
    }
    if(parseInt(el.value) > parseInt(el.max)){
      el.value = el.max;
    }
  }
}

// Custom Bulk order form development for CheapTshirtUSA.
// All right resereved by Cheap Tshirt USA © 2024.
// Developed by Senior Shopify Designer & Developer Arafat Jahan https://arafatjahan.com
// Version 1.3 revised 0.1
  
document.addEventListener("DOMContentLoaded", function() {
    // Hide all color divs by default
    $(".Color_warehouse_master_block").hide();

    // Check if there's a "White" or "Blanc" color div
    var hasWhite = $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").length > 0;

    // Check if there's a "Black" or "Noir" color div
    var hasBlack = $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").length > 0;

    // Check if any color is pre-selected
    var $preSelectedColorInput = $(".color-swatch input:checked");

    // Show the color div based on the conditions
    if ($preSelectedColorInput.length > 0) {
            // Show the pre-selected color div if there is available
            var preSelectedColor = normalizeColor($preSelectedColorInput.closest(".color-swatch").data("color"));
            $(".Color_warehouse_master_block." + normalizeDotColor(preSelectedColor)).show();
    } else if (hasWhite) {
        $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").show();
    } else if (hasBlack) {
        $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").show();
    } else {
        $(".Color_warehouse_master_block").first().show();
    }

  
$('.color-swatch').on('click', function() {
    var selectedColor = normalizeColor($(this).data('color')); // Normalize data attribute value

    // Find the dropdown option with the matching value
    var dropdownOption = $('.SelectOptions[value="' + selectedColor + '"]');

    // Get the color circle and text associated with the dropdown option
    var selectedColorCircle = dropdownOption.find('.color-circle').clone();
    var selectedColorText = dropdownOption.text();

    // Update the dropdown header with the selected color circle and text
    dropdownHeader.empty().append(arrow, selectedColorCircle, selectedColorText);

    // Show/hide color blocks based on selected color
    if (selectedColor) {
        $(".Color_warehouse_master_block").hide();
        $(".Color_warehouse_master_block." + normalizeDotColor(selectedColor)).show();
    } else {
        console.error("Failed to normalize color:", $(this).data("color"));
    }

    // Dispatch a custom event to update the new dropdown
    document.getElementById('colorDropdown').dispatchEvent(new CustomEvent('colorChange', { bubbles: true, detail: { color: selectedColor } }));

});

// Add event listener to update dropdown selection when custom event is triggered
document.getElementById("colorDropdown").addEventListener('colorChange', function(event) {
    // Extract the selected color from the event detail
    var selectedColor = event.detail.color;

    // Update the dropdown selection to match the selected color
    $("#colorDropdown").val(selectedColor).trigger("change");
});

// Handle click event on color swatches
  $(".color-swatch__radio").on("click", function() {
      // Add class to prevent triggering dropdown change event
      $("#colorDropdown").addClass("dropdown-triggered");
  });

  
// Define a variable to store the currently selected color
var selectedColor = "";

// Handle change event on color dropdown
document.getElementById("colorDropdown").addEventListener("colorChange", function(event) {
    if (!event.target.classList.contains("dropdown-triggered")) {
        var newSelectedColor = event.detail.color; // Get the newly selected color from event detail

        if (newSelectedColor === "Display All Colors") {
            // Show all color divs if "Display All Colors" is selected
            $(".Color_warehouse_master_block").show();

            // Update the toggle button text
            $("#toggleView").text("View 1 Color");
        } else {
            // Hide all color divs and show only the selected color
            $(".Color_warehouse_master_block").hide();
            $(".Color_warehouse_master_block." + normalizeDotColor(newSelectedColor)).show();

            // Trigger a click event on the corresponding color swatch radio button
            $(".color-swatch[data-color='" + newSelectedColor + "'] .color-swatch__radio").click();

            // Update the toggle button text if the selection is different from the last one
            if (newSelectedColor !== selectedColor) {
                $("#toggleView").text("Display All Colors");
               // Show the button only if "View 1 Color" is showed
                $("#add-to-cart-bulk-secondary").hide();
            }
        }
        // Update the selected color
        selectedColor = newSelectedColor;
    } else {
        // Remove the class to allow triggering dropdown change event in future
        event.target.classList.remove("dropdown-triggered");
    }
});


// Handle change event on color dropdown
document.getElementById("colorDropdown").addEventListener("click", function(event) {
    if (event.target.classList.contains("SelectOptions")) {
        var newSelectedColor = event.target.getAttribute('value'); // Get the newly selected color from dropdown

        if (newSelectedColor === "Display All Colors") {
            // Show all color divs if "Display All Colors" is selected
            document.querySelectorAll(".Color_warehouse_master_block").forEach(function(element) {
                element.style.display = "block";
            });

            // Update the toggle button text
            document.getElementById("toggleView").innerText = "View 1 Color";
        } else {
            // Hide all color divs and show only the selected color
            document.querySelectorAll(".Color_warehouse_master_block").forEach(function(element) {
                element.style.display = "none";
            });
           
            //Select the color div corresponding to the newSelectedColor and set its display style to "block"
            var colorDiv = document.querySelector(".Color_warehouse_master_block." + normalizeDotColor(newSelectedColor));
            if (colorDiv) {
                colorDiv.style.display = "block";
            } else {
                console.error("Color div not found for", newSelectedColor);
            }

            // Trigger a click event on the corresponding color swatch radio button
            var colorSwatchRadio = document.querySelector(".color-swatch[data-color='" + newSelectedColor + "'] .color-swatch__radio");
            if (colorSwatchRadio) {
                colorSwatchRadio.click();
            }

            // Update the toggle button text if the selection is different from the last one
            if (newSelectedColor !== selectedColor) {
                document.getElementById("toggleView").innerText = "Display All Colors";
                // Show the button only if "View 1 Color" is showed
                document.getElementById("add-to-cart-bulk-secondary").style.display = "none";
            }
        }
        // Update the selected color
        selectedColor = newSelectedColor;
    }
});

// Trigger the blink animation for the search input cursor
function blinkCursor() {
    var searchInput = document.getElementById("dropdownSearch");
    searchInput.focus(); // Ensure the search input is focused
    var cursor = document.createElement("span"); // Create a span element for the cursor
    cursor.className = "cursor"; // Add a class for styling
    searchInput.parentNode.appendChild(cursor); // Append the cursor to the search input parent element
    setInterval(function() {
        cursor.style.visibility = (cursor.style.visibility === 'visible' ? 'hidden' : 'visible'); // Toggle cursor visibility
    }, 500); // Change cursor visibility every 500ms (blink rate)
}

//Autofocus and Select the first element with class "Color_warehouse_master_block" and find its first input field
function focusOnFirstVisibleInput() {
    // Select all elements with class "Color_warehouse_master_block"
    const blocks = document.querySelectorAll('.Color_warehouse_master_block');

    // Iterate through the blocks to find the first visible one
    for (let block of blocks) {
        // Check if the block is displayed
        if (block.style.display === 'block') {
            const qtyField = block.querySelector('.quantity-input'); // Get the input field within this block
            if (qtyField) {
                qtyField.focus(); // Focus on the quantity input field
            }
            break; // Exit loop after focusing on the first visible block
        }
    }
}
// Call the function whenever needed
setTimeout(focusOnFirstVisibleInput, 300); // Adjust the delay as necessary
  

var dropdownHeader = $('.dropdown-header');
var dropdownOptions = $('.dropdownContentContainer');
var arrow = $('<span class="arrow">&#9660;</span>'); // Down arrow symbol

dropdownHeader.append(arrow); // Append arrow to the header initially

dropdownHeader.on('click', function() {
    dropdownOptions.toggle();
    if (dropdownOptions.is(":visible")) {
        arrow.html("&#9650;"); // Set arrow up when dropdown is open
    } else {
        arrow.html("&#9660;"); // Set arrow down when dropdown is closed
    }

    blinkCursor(); // Trigger the blink animation for the search input cursor
    event.stopPropagation(); // Prevent the click event from propagating to the document body
});

$('.SelectOptions').on('click', function() {
    var selectedColorCircle = $(this).find('.color-circle').clone(); // Clone color circle
    var selectedColorText = $(this).text(); // Get selected color text
    arrow.html("&#9660;"); // Set arrow down when color is selected
    dropdownHeader.empty().append(arrow, selectedColorCircle, selectedColorText); // Update header content with arrow, selected color, and circle
    dropdownOptions.hide();
    // Reset or empty the dropdownSearch input field
    $('#dropdownSearch').val('');
    // Show all options when clearing the search input
    $('.SelectOptions').show();
});

// Hide the dropdown when clicking outside of it
$(document).on('click', function(event) {
    if (!$(event.target).closest('.dropdown-container').length) {
        dropdownOptions.hide();
        arrow.html("&#9660;"); // Set arrow down when dropdown is closed
    }
});

// Define the filterDropdown function
function filterDropdown() {
  var input, filter, div, options, i, colorName;
  input = document.getElementById("dropdownSearch");
  filter = input.value.toUpperCase();
  div = document.getElementById("colorDropdown");
  options = div.getElementsByClassName("SelectOptions");
  for (i = 0; i < options.length; i++) {
    colorName = options[i].textContent.toUpperCase(); // Get the color name
    if (colorName.indexOf(filter) > -1) {
      options[i].style.display = ""; // Show the option if it matches the filter
    } else {
      options[i].style.display = "none"; // Hide the option if it doesn't match the filter
    }
  }
}

// Get the search input element
  var searchInput = document.getElementById("dropdownSearch");
  
// Add event listener for keyup event on the search input
  searchInput.addEventListener("keyup", filterDropdown);

// Function to toggle between Display All Colors and view one color
$("#toggleView").on("click", function() {
    var isViewAll = $(this).text() === "Display All Colors";

    if (isViewAll) {
        // Show all color divs
        $(".Color_warehouse_master_block").show();

        // Show the button only if "Display All Colors" is clicked
        $("#add-to-cart-bulk-secondary").show();
    } else {
        // Hide all color divs
        $(".Color_warehouse_master_block").hide();

        // Check if there is a selected color
        if (!selectedColor) {
            // Check if there are specific color divs for White/Blanc or Black/Noir
            var hasWhite = $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").length > 0;
            var hasBlack = $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").length > 0;

            // If White/Blanc or Black/Noir color divs are present, show them
            if (hasWhite) {
                $(".Color_warehouse_master_block.White, .Color_warehouse_master_block.Blanc").show();
            } else if (hasBlack) {
                $(".Color_warehouse_master_block.Black, .Color_warehouse_master_block.Noir").show();
            } else {
                // If no specific color divs are found, show the first color div
                $(".Color_warehouse_master_block").first().show();
            }
        } else {
            // Show the color div that was previously selected
            $(".Color_warehouse_master_block." + normalizeDotColor(selectedColor)).show();
        }

        // Show the button only if "View 1 Color" is clicked
        $("#add-to-cart-bulk-secondary").hide();
    }

    // Toggle the text of the button
    $(this).text(isViewAll ? "View 1 Color" : "Display All Colors");
});
  
// Function to normalize color names
    function normalizeColor(color) {
        // Normalize the color name as needed (e.g., remove spaces, special characters)
        return color.replace(/\s+/g, '').replace(/'/g, '').replace(/\//g, '');
    }
});

// Function to normalize color names (remove dots)
function normalizeDotColor(color) {
    // Normalize the color name as needed (e.g., remove spaces, special characters, dots)
    return color.replace(/\s+/g, '').replace(/'/g, '').replace(/\//g, '').replace(/\./g, '');
}  